import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import EnergyEffLinkBoxRow from '../../components/EnergyEffLinkBoxRow';

export type NOM_029_ENER_2017Props = {};

const NOM_029_ENER_2017: React.FC<NOM_029_ENER_2017Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "energy-efficiency",
          defaultMessage: "Energy Efficiency"
        })}
        subHeading='NOM-029-ENER-2017'
      />
      <EnergyEffLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex flex-col w-full pt-0 md:pt-6 pb-10 md:pb-0 gap-10">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                NOM-029-ENER-2017
              </h2>
              <p className="mb-3">
                {
                  intl.formatMessage({
                    id: "energy_eff_power_supply_1",
                  })
                }
              </p>
              <p>
                {
                  intl.formatMessage({
                    id: "energy_eff_power_supply_2",
                  })
                }
              </p>
              <ul className=' list-disc ml-6 mb-3'>
                <li>
                  {
                    intl.formatMessage({
                      id: "energy_eff_power_supply_3",
                    })
                  }
                </li>
                <li>
                  {
                    intl.formatMessage({
                      id: "energy_eff_power_supply_4",
                    })
                  }
                </li>
                <li>
                  {
                    intl.formatMessage({
                      id: "energy_eff_power_supply_5",
                    })
                  }
                </li>
              </ul>
              <p>
                {
                  intl.formatMessage({
                    id: "energy_eff_power_supply_6",
                  })
                }
              </p>
            </div>            
          </div>
          <div className="w-full mt-12 flex justify-center">
            <img className="max-w-3xl" src="/img/power-supplies-250.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NOM_029_ENER_2017;